
import React, { useState, ReactNode, useEffect } from 'react';
import './index.less';
import Step from '@/components/Step';
import StepFirst from '@/pages/selfClosure/stepFirst';
import StepSecond from '@/pages/selfClosure/stepSecond';
import StepThird from '@/pages/selfClosure/stepThird';
import Nav from '@/components/Nav';
import { checkWeGameBindDays } from '@/constants/api';
import useSWR from 'swr';
import { useOutletContext } from 'react-router-dom';
import { LoginInfo } from '@/types';
import { useSetAtom } from 'jotai';
import { loginAtom } from '@/utils/atoms';

const STEPS_MAP = [{
  title: '封停信息',
}, {
  title: '身份验证',
}, {
  title: '封停成功',
}];

const SelfClosure = () => {
  const [step, setStep] = useState(0);
  const [uuid, setUuid] = useState('');
  const [msg, setMsg] = useState('');
  const loginInfo: LoginInfo = useOutletContext();
  const setUpdateLogin = useSetAtom(loginAtom);

  useEffect(() => {
    if (!Object.keys(loginInfo).length) {
      setUpdateLogin({isLogin: false, visibleLogin: true});
    }
  }, [loginInfo]);

  const onfinsh = (value: number) => {
    setStep(value);
  };
  const { data } = useSWR(checkWeGameBindDays + '?isUnSelf=false');

  useEffect(() => {
    if (data && data.retCode !== 'SUCCESS') {
      setMsg(data.message);
    }
  }, [data]);

  const content: Record<number, ReactNode> = {
    0: <StepFirst onfinsh={onfinsh} setUuid={setUuid} />,
    1: <StepSecond onfinsh={onfinsh} uuid={uuid} />,
    2: <StepThird />,
  };

  return (
    <>
      <Nav activeMenu={'accountManagement'} />
      <div className='wgClosureBody'>
        <div className="wgClosureMain">
          <div className="wgContent">
            <h3 className="wgContentTitle">
              <span>游戏自助封停</span>
            </h3>
            {
              msg.indexOf('您未绑定光宇APP，无法使用此功能，请前往此处绑定') > -1 ? <p className='errorMsg'>{msg} <a href='http://we.gyyx.cn/hdzt/hd/p/gd/app/index.html'> 点击绑定</a></p> : <>
                <Step current={step} stepsMap={STEPS_MAP} />
                {content[step]}
                <div className="reminder">
                  <div>温馨提示：</div>
                  <p>封停账号后，将在提交的24小时内无法登录游戏。且游戏内角色下线，奇宝斋上架的角色及物品自动下架。</p>
                </div>
              </>
            }
          </div>
        </div>
      </div>
    </>
  );
};

export default SelfClosure;
